import React, {Component} from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  Platform,
  Dimensions,
  Image,
} from 'react-native';
import {Intro} from '../components/Intro';
import {Header} from '../components/Header';
import {Footer} from '../components/Footer';

export default class Home extends Component {
  render() {
    return (
      <View style={{flex: 1, justifyContent: 'space-between'}}>
        <View
          style={{
            width: Dimensions.get('screen').width > 720 ? '80%' : '94%',
            justifyContent: 'space-between',
            alignSelf: 'center',
            flexDirection:
              Dimensions.get('screen').width > 720 ? 'row' : 'column',
          }}>
          <View
            style={{
              width: Dimensions.get('screen').width > 720 ? '40%' : '94%',
            }}>
            <Text
              style={{
                fontSize: Dimensions.get('screen').width > 720 ? 48 : 24,
                color: '#44A9C9',
                fontWeight: 'bold',
              }}>
              Hello ! I'm Mridul
            </Text>
            <Intro fontSize={Dimensions.get('screen').width > 720 ? 24 : 18} />
            <TouchableOpacity style={{paddingTop: 20}}>
              <Text
                style={{
                  alignSelf: 'flex-start',
                  textDecorationLine: 'underline',
                  fontSize: 16,
                  fontWeight: '600',
                }}>
                More about me -{'>'}{' '}
              </Text>
            </TouchableOpacity>
            <View style={{height: 30}} />
          </View>
          <View
            style={{
              width: Dimensions.get('screen').width > 720 ? '40%' : '90%',
              alignSelf: 'center',
            }}>
            <Image
              source={require('../images/mridx.jpg')}
              style={{
                width:
                  Dimensions.get('screen').width > 720
                    ? 300
                    : Dimensions.get('screen').width - 100,
                height:
                  Dimensions.get('screen').width > 720
                    ? 300
                    : Dimensions.get('screen').width - 100,
                alignSelf:
                  Dimensions.get('screen').width > 720
                    ? 'flex-start'
                    : 'center',
                borderRadius:
                  Dimensions.get('screen').width > 720
                    ? 300 / 2
                    : Dimensions.get('screen').width / 2 - 50,
              }}
            />
          </View>
        </View>
      </View>
    );
  }
}
